import { Phone, ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "../ui/button";
import { SITE } from "../../lib/site";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/1f354b20-e4e3-4a91-b606-8bc67655a4db/images/8e3e369577c6366d3075b3f0b289187749a53872b136b7b1d7910d4d2277d1dd.png";
const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/1f354b20-e4e3-4a91-b606-8bc67655a4db/images/69fabb000d20ba18d8834728d00e0266ac203d0e39d8e7aab067126d6ade4e2b.png";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-36 pb-20 md:pb-28 overflow-hidden"
    >
      <img
        src={HERO_BG}
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover opacity-[0.08] mix-blend-multiply pointer-events-none"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-cream via-brand-cream/60 to-brand-cream pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 reveal">
          <div className="label-eyebrow text-brand-terracotta mb-6 flex items-center gap-3">
            <span className="h-px w-8 bg-brand-terracotta/60" />
            Mortgage Broker · {SITE.region}
          </div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-medium text-brand-ink leading-[1.02]">
            Building <em className="not-italic text-brand-terracotta">generational</em> wealth, one settlement at a time.
          </h1>
          <p className="mt-6 max-w-xl text-base md:text-lg text-brand-ink/70 leading-relaxed">
            At Empower Legacy Finance, our mission is to help Aussies build
            wealth and achieve their dreams through suitable finance strategies
            and cashflow management techniques — resulting in the creation of
            a lifestyle by design.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <a href={SITE.phoneTel} data-testid="hero-call-button">
              <Button
                size="lg"
                className="bg-brand-eucalyptus hover:bg-brand-eucalyptusDark text-brand-cream rounded-full h-14 px-7 text-base transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
              >
                <Phone className="h-5 w-5 mr-2" strokeWidth={1.8} />
                Call {SITE.phone}
              </Button>
            </a>
            <a href="#contact" data-testid="hero-enquire-button">
              <Button
                size="lg"
                variant="outline"
                className="rounded-full h-14 px-7 text-base border-brand-terracotta/40 text-brand-terracotta hover:bg-brand-terracotta hover:text-brand-cream transition-all duration-300"
              >
                Talk to a broker
                <ArrowRight className="h-5 w-5 ml-2" strokeWidth={1.8} />
              </Button>
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-brand-ink/60">
            <div className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-brand-terracotta" strokeWidth={1.6} />
              FBAA Accredited
            </div>
            <div>40+ Australian lenders</div>
          </div>
        </div>

        <div className="lg:col-span-5 reveal" style={{ animationDelay: "120ms" }}>
          <div className="relative">
            <div className="absolute -top-4 -left-4 right-12 bottom-12 rounded-3xl bg-brand-sand -z-0" />
            <div className="relative rounded-3xl overflow-hidden shadow-xl border border-border">
              <img
                src={HERO_IMG}
                alt="Premium Australian coastal property at golden hour"
                className="w-full h-[420px] sm:h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-2 sm:left-6 bg-brand-cream rounded-2xl border border-border shadow-lg px-5 py-4 flex items-center gap-4 max-w-xs">
              <div className="h-10 w-10 rounded-full bg-brand-eucalyptus text-brand-cream grid place-items-center">
                <Phone className="h-4 w-4" strokeWidth={1.8} />
              </div>
              <div>
                <div className="text-xs uppercase tracking-widest text-brand-ink/50">Talk to a broker</div>
                <a
                  href={SITE.phoneTel}
                  data-testid="hero-floating-phone"
                  className="font-display text-lg text-brand-eucalyptus hover:text-brand-terracottaDark"
                >
                  {SITE.phone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
